import axios from 'axios';

const API_URL = 'https://qm.cafe-depastoor.nl/backend/api/';  // Change this to your actual server URL

export const setQuizConfig = async (data) => {
  return axios.post(`${API_URL}config.php`, data);
};


export const registerTeam = async (code, name) => {
  return axios.post(`${API_URL}register_team.php`, { code, name });
};

// ADD THIS NEW FUNCTION
export const submitAnswer = async (roundId, questionNumber, text) => {
  try {
    const response = await axios.post(`${API_URL}answers.php`, {
      round_id: roundId,
      question_number: questionNumber,
      text: text,
    });
    return response.data;
  } catch (error) {
    console.error('Error saving answer:', error);
    throw error;
  }
};

// Add this at the bottom of api.js
export const submitAnswersForRound = async (roundId, answers) => {
  try {
    const response = await axios.post(`${API_URL}answers.php`, {
      round_id: roundId,
      answers: answers.map((text, index) => ({ question_number: index + 1, text })),
    });
    return response.data;
  } catch (error) {
    console.error('Error saving answers:', error);
    // Don't throw to avoid crashing UI
  }
};